export default function describeCoverageAlt(value) {
    const numberValue = typeof value === 'number'
        ? value
        : parseInt(value, 10);

    switch (Math.round(numberValue)) {
        case 4:
            return "Excellent Mobile Coverage";
        case 3:
            return "Good Mobile Coverage";
        case 2:
            return "Some Mobile Coverage";
        case 1:
            return "Major Mobile Coverage Issues";
        case 0:
            return "No Mobile Service";
        default:
            return "";
    }
}
